class Accordion {
  constructor() {
    this.details = Array.from(document.querySelectorAll('.js-accordion'));
    this.init();
  }

  init() {
    this.details.forEach(detail => {
      detail.addEventListener('click', e => {
        const active = this.details.find(d => d.open);
        if (!e.currentTarget.open && active) {
          active.open = false;
        }
      });
    });
  }
}

export default Accordion;
